import { render, staticRenderFns } from "./BrowseSidebar.vue?vue&type=template&id=5239c722"
import script from "./BrowseSidebar.vue?vue&type=script&lang=js"
export * from "./BrowseSidebar.vue?vue&type=script&lang=js"
import style0 from "./BrowseSidebar.vue?vue&type=style&index=0&id=5239c722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports